<div class="doc-main-div">
  <div class="doc-top-div">
    <div class="docs-logo">
      <a *ngIf="global.getCluster()!='germany' && locale == 'en'" href="/docs"><img src="{{config.getBaseUrl()+'doc/file/get_image?name=logoEN1.svg'}}" style="width: 135px"></a>
      <a *ngIf="global.getCluster()!='germany' && locale == 'fa'" href="/docs"><img src="{{config.getBaseUrl()+'doc/file/get_image?name=logo1.png'}}" style="width: 135px"></a>
      <a *ngIf="global.getCluster()=='germany'" href="/docs"><img src="{{config.getBaseUrl()+'doc/file/get_image?name=logo_de.png'}}" style="width: 135px"></a>
    </div>
    <div class="docs-right">
      <div class="doc-menu" *ngFor="let doc of listDocs">
        <div style="width: calc(100% - 20px);">
          <i (click)="selectDoc(doc)"
             style="{{selectedDoc.id==doc.id?'color:#b30606;text-shadow: 0px 0px 1px #060200;width: 100%':'width: 100%'}} ">{{doc.label}}</i>
        </div>
        <div style="width: 20px;text-align: center;margin-top: -2px;">
          <i style="margin: 2px;font-size: 10px;" (click)="openEditDocDialog(doc)" class="pi pi-pencil"></i>
        </div>

      </div>
    </div>
    <div class="docs-left">
      <div class="new-doc"><i class="ico icon-folder-plus " (click)="addDocDialog()" i18n-pTooltip="@@New Doc"  pTooltip="New Doc"></i></div>

    </div>


  </div>
  <div class="doc-center-div">
    <div class="doc-right-div">
      <div class="new-right-top">
        <div style="{{getDirection()=='rtl'?'float: right':'float: left'}}" i18n="@@Index">Index</div>
        <i class="ico icon-book" (click)="openNewCategory()"  i18n-pTooltip="@@New Group" pTooltip="New Group"></i>
        <i class="ico icon-file" (click)="openRootNewPageDialog()" i18n-pTooltip="@@New Page" pTooltip="New Page"></i>
      </div>
      <div class="category-tree">
        <p-tree [value]="categoryTree" emptyMessage=" " selectionMode="single" [(selection)]="selectedTree"
                (onNodeSelect)="nodePageSelect($event)" [contextMenu]="cm"></p-tree>
        <p-contextMenu #cm [model]="contextItems" (onShow)="showContextMenu()"></p-contextMenu>
      </div>
    </div>
    <div class="doc-left-div">
      <div class="doc-left-top">

        <div style="width: 50%;text-align: start;">
          <i *ngIf="selectedPage.publish && selectedPage.lastPublish == selectedPage.lastUpdate"
             pTooltip="Published" i18n-pTooltip="@@Published" style="color: rgb(16 162 27);text-shadow: green 0px 0px 3px;" class="pi pi-eye"></i>
          <i *ngIf="selectedPage.publish && selectedPage.lastPublish != selectedPage.lastUpdate"
             pTooltip="Published" i18n-pTooltip="@@Published" style="color: rgb(255 197 16);text-shadow: 0px 0px 2px black;" class="pi pi-eye"></i>
          <i *ngIf="!selectedPage.publish" pTooltip="Not Published" i18n-pTooltip="@@Not Published"   style="color: red;text-shadow: 0px 0px 2px black;" class="pi pi-eye-slash"></i>
        </div>
        <div style="width: 50%;text-align: end;">
          <i class="ico icon-file2" *ngIf="this.selectedPage.id!= null && this.selectedPage.id>0" style="font-size: 20px"
             (click)="openNewPostDialog()" i18n-pTooltip="@@New Post" pTooltip="New Post" ></i>
          <i class="ico icon-images" *ngIf="this.selectedPage.id!= null && this.selectedPage.id>0"
             (click)="openImageCenter(imgDV)" i18n-pTooltip="@@Image Manager" pTooltip="Image Manager"></i>
          <i class="ico icon-publish" *ngIf="this.selectedPage.id!= null && this.selectedPage.id>0"
             (click)="savePublishPage()" i18n-pTooltip="@@Publish Page" pTooltip="Publish Page"></i>
        </div>

      </div>
      <div *ngIf="!global.hidePostMain" class="post-main-div">
        <div class="page-navigation">
          <div>{{selectedDoc.label}}</div>
          <div *ngFor="let cat of creatNavCategoryList()"><i class="pi {{getDirection()=='rtl'?'pi-angle-left':'pi-angle-right'}}"></i>{{cat.name}}</div>
          <div><i class="pi {{getDirection()=='rtl'?'pi-angle-left':'pi-angle-right'}} "></i>{{selectedPage.label}}</div>
        </div>
        <div class="select-none" style="color: #b5b2b2;{{getDirection()=='rtl'?'padding-right: 10px;':'padding-left: 10px;'}}"
             *ngIf="selectedPage && selectedPage.id>0">
          <div  style="position: relative;font-size: 12px;padding: 0px 7px;" class="pi pi-clock"></div>
          <span *ngIf="getDirection()=='rtl'" >{{miliSecontToDate(selectedPage.lastUpdate) | dateText : "dd d m yyyy"  }} </span>
          <span *ngIf="getDirection()=='ltr'" >{{miliSecontToDate(selectedPage.lastUpdate) | dateText : "dd D-M-yyyy"  }} </span>
        </div>
        <div *ngFor="let post of selectedPage.posts ; let j = index" class="grid post-div">
          <div (click)="copyToClipboard(getHost()+'/'+locale+'/docs/permalink/'+selectedPage.uid+'/'+post.uid)"
               class=" hashtag col-6 post-title" id="{{creatPostTag(post)}}">
            <h2 style="cursor: pointer" i18n-pTooltip="@@Link Copy" pTooltip="Link Copy" >{{post.label}}</h2> <a
            href="{{creatPostTagLink(post)}}">#</a></div>
          <div class="col-6" style="text-align:end;{{getDirection()=='rtl' ?'direction: rtl;':'direction: ltr;'}}">
            <i class="ico icon-file" style="font-size: 20px" (click)="showNewItemDialog(post)"
               i18n-pTooltip="@@Add New Item" pTooltip="Add New Item"></i>
            <i class="ico icon-pencil" (click)="showEitePostDialog(post,j)" i18n-pTooltip="@@Edit Post" pTooltip="Edit Post"></i>
            <i class="pi pi-trash" (click)="removePostFromPage(post)" i18n-pTooltip="@@Delete Post" pTooltip="Delete Post"></i>
            <i class="ico icon-chevron-up" *ngIf="j>0" (click)="upPost(selectedPage,j);cm.hide()"
               i18n-pTooltip="@@Move up" pTooltip="Move up"></i>
            <i class="ico icon-chevron-down" *ngIf="j<selectedPage.posts.length-1"
               (click)="downPost(selectedPage,j);cm.hide()"
              i18n-pTooltip="@@Move down" pTooltip="Move down"></i>
          </div>
          <div *ngFor="let item of post.postItems ; let i = index"
               class=" {{item.itemAttribute.widthClass ?item.itemAttribute.widthClass:'col-12' }} post-item"
               id="{{j+''+i}}">
            <div class="item-icon-bar">
              <i class="pi pi-trash" style="display: initial" (click)="removeItem(post,item)"
                 i18n-pTooltip="@@Delete Item" pTooltip="Delete Item"></i>
              <i class="ico icon-pencil" (click)="openEditPostItem(item)" pTooltip="Edit Item"></i>
              <i class="ico icon-chevron-up" [hidden]="i<1" (click)="upItem(post,i)" i18n-pTooltip="@@Move up" pTooltip="Move up"></i>
              <i class="ico icon-chevron-down" [hidden]="i>=post.postItems.length-1" (click)="downItem(post,i)"
                 i18n-pTooltip="@@Move down" pTooltip="Move down"></i>
            </div>
<!--            <div [innerHTML]="item.html_not_publish | safeHtml"></div>-->
            <div [innerHTML]="showItemInPost(post,item) | safeHtml"></div>
          </div>
        </div>
      </div>

    </div>

  </div>
</div>


<!--...............................................................................................-->
<p-dialog i18n-header="@@Doc" header="Doc" [resizable]="false"
          [(visible)]="displayNewDoc" [responsive]="true"
          showEffect="fade" [modal]="true" [closable]="true" [style]="{'width':'250px'}">
  <div class="itemInput">
    <div><label i18n="@@English Name">English Name</label></div>
    <input pInputText style="direction: ltr" [(ngModel)]="newDoc.name">
  </div>
  <div class="itemInput">
    <div><label i18n="@@Label">Label</label></div>
    <input pInputText [(ngModel)]="newDoc.label">
  </div>
  <div class="itemInput">
    <div><label i18n="@@Publish">Publish </label></div>
    <p-inputSwitch [(ngModel)]="newDoc.publish"></p-inputSwitch>
  </div>
  <p-footer>
    <button [disabled]="checkValidName(newDoc.name)" pButton i18n-label="@@Save" label="Save" (click)="addDoc()"></button>
    <button [disabled]="checkValidName(newDoc.name)" *ngIf="newDoc.id>0" pButton i18n-label="@@Delete Doc" label="Delete Doc"
            (click)="deleteDocDialog()"></button>
  </p-footer>
</p-dialog>
<!--..............................................................................................-->
<p-dialog i18n-header="@@Group" header="Group" [resizable]="false"
          [(visible)]="displayNewCategory" [responsive]="true"
          showEffect="fade" [modal]="true" [closable]="true" [style]="{'width':'400px'}">
  <div style="height: 340px">
    <div class="itemInput">
      <div><label i18n="@@Title">Title</label></div>
      <input pInputText [(ngModel)]="newCategory.name">
    </div>

    <div class="itemInput" style="margin-top: 5px">
      <div><label i18n="@@Parent Group">Parent Group</label></div>
      <p-autoComplete [(ngModel)]="newCategory.parent"
                      [suggestions]="filteredCategory"
                      (completeMethod)="filterCategory($event)"
                      field="name" [dropdown]="true">
        <ng-template let-category pTemplate="item">
          <div class="autoCompleteDiv">
            <div>{{category.name}}</div>
          </div>
        </ng-template>
      </p-autoComplete>
    </div>
  </div>

  <p-footer>
    <button pButton i18n-label="@@Save" label="Save" (click)="addCategory()"></button>
    <!--    <button *ngIf="newCategory && newCategory.id>0" pButton label="حذف گروه" (click)="deleteCategoryDialog()"></button>-->
  </p-footer>
</p-dialog>
<!--.........................................................................................................-->
<p-dialog i18n-header="@@Page" header="Page" [resizable]="false"
          [(visible)]="displayNewPage" [responsive]="true"
          showEffect="fade" [modal]="true" [closable]="true" [style]="{'width':'400px'}">

  <div style="height: 350px">
    <div class="itemInput">
      <div><label i18n="@@Parent Group">Parent Group</label></div>
      <p-autoComplete [(ngModel)]="selectedCategory"
                      [suggestions]="filteredCategory"
                      (completeMethod)="filterCategory($event)"
                      field="name" [dropdown]="true">
        <ng-template let-category pTemplate="item">
          <div class="autoCompleteDiv">
            <div>{{category.name}}</div>
          </div>
        </ng-template>
      </p-autoComplete>
    </div>
    <div class="itemInput">
      <div><label i18n="@@English Name">English Name</label></div>
      <input pInputText style="direction: ltr" [(ngModel)]="newPage.name">
    </div>
    <div class="itemInput">
      <div><label i18n="@@Label">Label</label></div>
      <input pInputText [(ngModel)]="newPage.label">
    </div>
    <div class="itemInput">
      <div><label i18n="@@Publish">Publish</label></div>
      <p-inputSwitch [(ngModel)]="newPage.publish"></p-inputSwitch>
    </div>

  </div>
  <p-footer>
    <button [disabled]="checkValidName(newPage.name)" pButton i18n-label="@@Save" label="Save" (click)="saveEditPage()"></button>
    <button [disabled]="checkValidName(newPage.name)" *ngIf="newPage && newPage.id>0" pButton i18n-label="@@Delete Page" label="Delete Page"
            (click)="deletePageDialog()"></button>
  </p-footer>
</p-dialog>
<!--..........................................................................................................-->
<p-dialog i18n-header="@@Post" header="Post" [resizable]="false"
          [(visible)]="displayNewPost" [responsive]="true"
          showEffect="fade" [modal]="true" [closable]="true" [style]="{'width':'400px'}">
  <div style="height: 250px">
    <div class="itemInput">
      <div><label i18n="@@English Name">English Name</label></div>
      <input pInputText style="direction: ltr" [(ngModel)]="newPost.name">
    </div>
    <div class="itemInput">
      <div><label i18n="@@Label">Label</label></div>
      <input pInputText [(ngModel)]="newPost.label">
    </div>
    <div class="itemInput">
      <div><label i18n="@@Hash Tag Title"> Hash Tag Title </label></div>
      <!--      <textarea pInputTextarea [(ngModel)]="newPost.hashtag"></textarea>-->
      <p-chips #chips1 [inputStyle]="{'width':'100%'}" ngDefaultControl [(ngModel)]="hashtagList"
               (onRemove)="setNewPostHashtag()"
               (onAdd)="setNewPostHashtag()"></p-chips>
    </div>
  </div>
  <p-footer>
    <button *ngIf="!postEditMode" [disabled]="checkValidName(newPost.name)" pButton i18n-label="@@Add Post" label="Add Post"
            (click)="addPostToPage(false)"></button>
    <button *ngIf="postEditMode" [disabled]="checkValidName(newPost.name)" pButton i18n-label="@@Edit Post" label="Edit Post"
            (click)="addPostToPage(true)"></button>
  </p-footer>
</p-dialog>
<!--.........................................................................................................-->
<p-dialog i18n-header="@@Item Type" header="Item Type" [resizable]="false"
          [(visible)]="displayItemType" [responsive]="true"
          showEffect="fade" [modal]="true" [closable]="true" [style]="{'width':'500px'}">
  <div class="grid select-item-btns">

    <div class="lg:col-3 sm:col-12">
      <p-button i18n-label="@@Label" label="Label" (click)="selectTypeItemDialog('TITLE')"></p-button>
    </div>
    <div class="lg:col-3 sm:col-12">
      <p-button i18n-label="@@Text" label="Text" (click)="selectTypeItemDialog('TEXT')"></p-button>
    </div>
    <div class="lg:col-3 sm:col-12">
      <p-button i18n-label="@@Taxt Box" label="Text Box" (click)="selectTypeItemDialog('TEXTBOX')"></p-button>
    </div>

    <!--    <div class="lg:col-3 sm:col-12">-->
    <!--      <p-button label="تگ" (click)="selectTypeItemDialog('TAG')"></p-button>-->
    <!--    </div>-->
    <div class="lg:col-3 sm:col-12">
      <p-button i18n-label="@@Note"  label="Note" (click)="selectTypeItemDialog('NOTE')"></p-button>
    </div>

    <div class="lg:col-3 sm:col-12">
      <p-button i18n-label="@@Image" label="Image" (click)="selectTypeItemDialog('IMAGE')"></p-button>
    </div>
    <div class="lg:col-3 sm:col-12">
      <p-button i18n-label="@@List" label="List" (click)="selectTypeItemDialog('LIST')"></p-button>
    </div>
    <div class="lg:col-3 sm:col-12">
      <p-button i18n-label="@@Code" label="Code" (click)="selectTypeItemDialog('CODE')"></p-button>
    </div>
    <div class="lg:col-3 sm:col-12">
      <p-button label="API" (click)="selectTypeItemDialog('API')"></p-button>
    </div>
    <div class="lg:col-3 sm:col-12">
      <p-button i18n-label="@@Space" label="Space" (click)="selectTypeItemDialog('SPACE')"></p-button>
    </div>

  </div>
</p-dialog>
<!--...........................................-->
<p-dialog i18n-header="@@Image Manager" header="Image Manager" [resizable]="false"
          [(visible)]="displayImageCenter" [responsive]="true"
          showEffect="fade" [modal]="true" [closable]="true" [style]="{'width':'90%'}">
  <div class="  lg:col-12">
    <p-fileUpload mode="basic" name="file" url="{{config.getBaseUrl()+'doc/file/upload?type=ImgUpload'}}" accept="image/*"
                  [maxFileSize]="100000" (onUpload)="getImgList(imgDV)"></p-fileUpload>
  </div>
  <div class="lg:col-12" style="height:{{getCenterHeight()-200}}px;">
    <p-dataView #imgDV [value]="listUploadFile" [totalRecords]="totalImage" [lazy]="true" (onLazyLoad)="getImgList($event)"
                [paginator]="true" [rows]="12" filterBy="name"
                layout="grid">
      <ng-template let-img pTemplate="gridItem">

          <div class="img-list-item">
            <div *ngIf="!img.used" style="color:red;cursor: pointer;position: absolute;{{getDirection()=='rtl'?'margin-right: -21px;':'margin-left: -21px;'}}" class="pi pi-trash" (click)="deleteIMG(img.id ,imgDV)" ></div>
            <img style="width: 200px;max-width: 200px;cursor: pointer;" [src]="config.getBaseUrl()+'doc/file/get_pic?uid=' +img.uid " [alt]="img.name"
                 (click)="imgSelectable==true ? selectImage(img) : copyToClipboard(config.getBaseUrl()+'doc/file/get_pic?uid=' +img.uid)" />
            <div class="img-list-detail"  (click)="imgSelectable==true ? selectImage(img) : copyToClipboard(config.getBaseUrl()+'doc/file/get_pic?uid=' +img.uid)">
              <div class="img-name">{{img.name}}</div>
            </div>
          </div>

      </ng-template>

    </p-dataView>
  </div>

</p-dialog>

<div [hidden]="!configDialog" class="divDialog">
  <div style="height: 600px">
    <p-tabView [(activeIndex)]="activeConfig">
      <p-tabPanel style="height: 500px" *ngIf="tempPostItem.type=='TITLE'" i18n-header="@@Title Info" header="Title Info">
        <div class="item-tabpnl-div">
          <div class="itemInput">
            <div><label i18n-="@@Title">Title</label></div>
            <input pInputText [(ngModel)]="tempPostItem.itemAttribute.value"/>
          </div>
          <div  class="itemInput">
            <div><label i18n="@@Style" >Style</label></div>
            <select [(ngModel)]="tempPostItem.itemAttribute.class_style">
              <option selected="selected" value="searchia-docs-title" i18n="@@Style 1">Style 1</option>
            </select>
          </div>
          <div class="itemInput">
            <div><label i18n="@@Item Width">Item Width</label></div>
            <select [(ngModel)]="tempPostItem.itemAttribute.widthClass">
              <option selected="selected" value="col-12">100%</option>
              <option selected="selected" value="col-9">75%</option>
              <option selected="selected" value="col-6">50%</option>
              <option selected="selected" value="col-4">33%</option>
              <option selected="selected" value="col-3">25%</option>
            </select>
          </div>
        </div>
      </p-tabPanel>
      <p-tabPanel style="height: 600px" *ngIf="tempPostItem.type=='NOTE'" i18n-header="@@Note" header="Note">
        <div class="item-tabpnl-div">
          <div class="itemInput">
            <div><label i18n="@@Type">Type </label></div>
            <select [(ngModel)]="tempPostItem.itemAttribute.type">
              <option i18n-value="@@Note" value="Note" selected="selected" i18n="@@Note">Note</option>
              <option i18n-value="@@Important Note" value="Important Note" i18n="@@Important Note">Important Note</option>
              <option i18n-value="@@Error" value="Error" i18n="@@Error">Error</option>
              <option i18n-value="@@Warning" value="Warning" i18n="@@Warning">Warning</option>
              <option i18n-value="@@Reminder" value="Reminder" i18n="@@Reminder">Reminder</option>
              <option i18n-value="@@Example" value="Example" i18n="@@Example">Example</option>
            </select>
          </div>
          <div class="itemInput">
            <div><label i18n="@@Text">Text</label></div>
            <!--            <textarea pInputTextarea style="height: 100px" [autoResize]="false" [(ngModel)]="tempPostItem.itemAttribute.value"></textarea>-->
            <ngx-suneditor #suneditorNote style="width: 100%"></ngx-suneditor>
          </div>
          <div class="itemInput">
            <div><label i18n="@@Style">Style</label></div>
            <select [(ngModel)]="tempPostItem.itemAttribute.class_style">
              <option value="searchia-docs-notice1" selected="selected" i18n="@@Info 1">Info 1</option>
              <option value="searchia-docs-notice2"  i18n="@@Info 2">Info 2</option>
              <option value="searchia-docs-notice-danger"  i18n="@@Error 1">Error 1</option>
              <option value="searchia-docs-warning1"  i18n="@@ Warning 1">Warning 1</option>
              <option value="searchia-docs-warning2"  i18n="@@Warning 2">Warning 2</option>
            </select>
          </div>
          <div class="itemInput">
            <div><label i18n="@@Item Width">Item Width</label></div>
            <select [(ngModel)]="tempPostItem.itemAttribute.widthClass">
              <option selected="selected" value="col-12">100%</option>
              <option selected="selected" value="col-9">75%</option>
              <option selected="selected" value="col-6">50%</option>
              <option selected="selected" value="col-4">33%</option>
              <option selected="selected" value="col-3">25%</option>
            </select>
          </div>
        </div>
      </p-tabPanel>
      <p-tabPanel style="height: 600px" *ngIf="tempPostItem.type=='TAG'" i18n-header="@@Tag" header="Tag">
        <div class="item-tabpnl-div">
          <div class="itemInput">
            <div><label i18n="@@Tag Text Title"> Tag Text Title</label></div>
            <textarea pInputTextarea style="height: 100px" [autoResize]="false"
                      [(ngModel)]="tempPostItem.itemAttribute.value"></textarea>
          </div>
          <div>
            <div><label i18n="@@Style">Style</label></div>
            <select [(ngModel)]="tempPostItem.itemAttribute.class_style">
              <option selected="selected" value="searchia-docs-tag" i18n="@@Style 1">Style 1</option>
              <option value="searchia-docs-tag-nobg" i18n="@@Style 2">Style 2</option>
              <option value="searchia-docs-tag-muted" i18n="@@Style 3">Style 3</option>
            </select>
          </div>
          <div class="itemInput">
            <div><label i18n="@@Item Width">Item Width</label></div>
            <select [(ngModel)]="tempPostItem.itemAttribute.widthClass">
              <option selected="selected" value="col-12">100%</option>
              <option selected="selected" value="col-9">75%</option>
              <option selected="selected" value="col-6">50%</option>
              <option selected="selected" value="col-4">33%</option>
              <option selected="selected" value="col-3">25%</option>
            </select>
          </div>
        </div>
      </p-tabPanel>
      <p-tabPanel style="height: 600px" *ngIf="tempPostItem.type=='SPACE'" i18n-header="@@Space" header="Space">
        <div class="item-tabpnl-div">
          <div class="itemInput">
            <div><label i18n="@@Item Width">Item Width</label></div>
            <select [(ngModel)]="tempPostItem.itemAttribute.widthClass">
              <option selected="selected" value="col-12">100%</option>
              <option selected="selected" value="col-9">75%</option>
              <option selected="selected" value="col-6">50%</option>
              <option selected="selected" value="col-4">33%</option>
              <option selected="selected" value="col-3">25%</option>
            </select>
          </div>
        </div>
      </p-tabPanel>
      <p-tabPanel style="height: 600px" *ngIf="tempPostItem.type=='DIVIDER'" i18n-header="@@Divider" header="Divider">
        <div class="item-tabpnl-div">
          <div class="itemInput">
            <div><label i18n="@@Style">Style</label></div>
            <select [(ngModel)]="tempPostItem.itemAttribute.class_style">
              <option selected="selected" value="searchia-docs-title-divider" i18n="@@Light" >Light</option>
              <option value="searchia-docs-title-divider2" i18n="@@Red">Red</option>
              <option value="searchia-docs-title-divider3" i18n="@@Blue">Blue</option>
            </select>
          </div>
        </div>
      </p-tabPanel>
      <p-tabPanel style="height: 500px" *ngIf="tempPostItem.type=='TEXT'" i18n-header="@@Text Info" header="Text Info">
        <div class="item-tabpnl-div">
          <div class="itemInput">
            <div><label i18n="@@Text">Text </label> <i class="ico icon-images" *ngIf="this.selectedPage.id!= null && this.selectedPage.id>0"
                                        (click)="openImageCenter(imgDV);" i18n-pTooltip="@@Image Manager" pTooltip="Image Manager"></i></div>
            <ngx-suneditor #suneditor style="width: 100%;height: 300px"></ngx-suneditor>
          </div>
        </div>
      </p-tabPanel>
      <p-tabPanel style="height: 600px" *ngIf="tempPostItem.type=='CODE'" i18n-header="@@Code" header="Code">
        <div class="item-tabpnl-div">
          <div class="itemInput">
            <div><label i18n="@@Type">Type</label></div>
            <select [(ngModel)]="tempPostItem.itemAttribute.type">
              <option selected="selected" value="code">Code</option>
              <option value="shell">Shell</option>
            </select>
          </div>
          <div class="itemInput">
            <div><label i18n="@@Description">Description</label></div>
            <textarea pInputTextarea style="height: 100px" [autoResize]="false"
                      [(ngModel)]="tempPostItem.itemAttribute.description"></textarea>
          </div>
          <div
            style="width: 100%;display: flex;border: 1px solid #d4d4d4;padding: 12px;margin: 10px 0px;border-radius: 5px;">
            <div style="width: 70px;">
              <button pButton i18n-pTooltip="@@New Tab" pTooltip="New Tab"
                      style="font-size: 20px;padding: 0px;width: 20px;min-width: 30px;margin-top: 10px;" label="+"
                      (click)="codeItemNewTab()"></button>
            </div>
            <div style="width: calc(100% - 30px);">
              <p-tabView>
                <p-tabPanel *ngFor="let coditem of codeItemValue" [header]="coditem['title']">
                  <div class="itemInput">
                    <div><label i18n="@@Tab Title">Tab Title</label></div>
                    <input pInputText [(ngModel)]="coditem['title']">
                  </div>
                  <div class="itemInput">
                    <div><label i18n="@@Code">Code</label></div>
                    <textarea pInputTextarea style="direction:ltr;height: 100px" [autoResize]="false"
                              [(ngModel)]="coditem['value']"></textarea>
                  </div>
                </p-tabPanel>
              </p-tabView>
            </div>

          </div>

          <div class="itemInput">
            <div><label i18n="@@Style">Style</label></div>
            <select [(ngModel)]="tempPostItem.itemAttribute.class_style">
              <option selected="selected" value="searchia-docs-code1" i18n="@@Style 1">Style 1</option>
              <option value="searchia-docs-code2" i18n="@@Style 2">Style 2</option>
              <option value="searchia-docs-code3" i18n="@@Style 3">Style 3</option>
            </select>
          </div>
          <div class="itemInput">
            <div><label i18n="@@Item Width">Item Width</label></div>
            <select [(ngModel)]="tempPostItem.itemAttribute.widthClass">
              <option selected="selected" value="col-12">100%</option>
              <option selected="selected" value="col-9">75%</option>
              <option selected="selected" value="col-6">50%</option>
              <option selected="selected" value="col-4">33%</option>
              <option selected="selected" value="col-3">25%</option>
            </select>
          </div>
        </div>
      </p-tabPanel>
      <p-tabPanel style="height: 600px" *ngIf="tempPostItem.type=='API'" header="Api">
        <div class="item-tabpnl-div">
          <div class="itemInput">
            <div><label i18n="@@Type">Type</label></div>
            <select [(ngModel)]="tempPostItem.itemAttribute.type">
              <option selected="selected" value="GET">GET</option>
              <option value="POST">POST</option>
              <option value="PUT">PUT</option>
              <option value="DELETE">DELETE</option>
            </select>
          </div>

          <div class="itemInput">
            <div><label i18n="@@Code">Code</label></div>
            <textarea pInputTextarea style="direction:ltr;height: 100px" [autoResize]="false"
                      [(ngModel)]="tempPostItem.itemAttribute.value"></textarea>
          </div>
          <div class="itemInput">
            <div><label i18n="@@Style">Style</label></div>
            <select [(ngModel)]="tempPostItem.itemAttribute.class_style">
              <option selected="selected" value="searchia-docs-api-get">GET</option>
              <option value="searchia-docs-api-post">POST</option>
              <option value="searchia-docs-api-put">PUT</option>
              <option value="searchia-docs-api-delete">DELETE</option>
            </select>
          </div>
          <div class="itemInput">
            <div><label i18n="@@Item Width">Item Width</label></div>
            <select [(ngModel)]="tempPostItem.itemAttribute.widthClass">
              <option selected="selected" value="col-12">100%</option>
              <option selected="selected" value="col-9">75%</option>
              <option selected="selected" value="col-6">50%</option>
              <option selected="selected" value="col-4">33%</option>
              <option selected="selected" value="col-3">25%</option>
            </select>
          </div>
        </div>
      </p-tabPanel>
      <p-tabPanel style="height: 500px" *ngIf="tempPostItem.type=='IMAGE'" i18n-header="@@Image" header="Image">
        <div class="item-tabpnl-div">
<!--          <div class="itemInput">-->
<!--            <div><label>آپلود تصویر</label></div>-->
<!--            <input type='file' id="inputSynonym"-->
<!--                   accept='image/*'-->
<!--                   (change)='addImage($event)'>-->
<!--          </div>-->
          <div class="itemInput">
            <div><label i18n="@@Image Address">Image Address</label> <i class="ico icon-images" *ngIf="this.selectedPage.id!= null && this.selectedPage.id>0"
                                              (click)="imgSelectable=true;openImageCenter(imgDV);" i18n-pTooltip="@@Image Manager" pTooltip="Image Manager"></i></div>
            <input pInputText [(ngModel)]="tempPostItem.itemAttribute.src" >
          </div>
          <div class="itemInput">
            <div><label i18n="@@Title">Title</label></div>
            <input pInputText [(ngModel)]="tempPostItem.itemAttribute.label"/>
          </div>
          <div class="itemInput">
            <div><label i18n="@@Image Width">Image Width</label></div>
            <select [(ngModel)]="tempPostItem.itemAttribute.width">
              <option selected="selected" value="100%">100%</option>
              <option value="75%">75%</option>
              <option  value="50%">50%</option>
              <option  value="33%">33%</option>
              <option  value="25%">25%</option>
              <option  value="15%">15%</option>
            </select>
          </div>
          <div class="itemInput">
            <div><label i18n="@@Item Width">Item Width</label></div>
            <select [(ngModel)]="tempPostItem.itemAttribute.widthClass">
              <option selected="selected" value="col-12">100%</option>
              <option  value="col-9">75%</option>
              <option  value="col-6">50%</option>
              <option  value="col-4">33%</option>
              <option  value="col-3">25%</option>
            </select>
          </div>

        </div>
      </p-tabPanel>
      <p-tabPanel style="height: 500px" *ngIf="tempPostItem.type=='LIST'" i18n-header="@@List" header="List">
        <div class="item-tabpnl-div">
          <div class="itemInput">
            <div><label i18n="@@List Text Title">List Text Title</label></div>
            <textarea pInputTextarea style="height: 100px" [autoResize]="false"
                      [(ngModel)]="tempPostItem.itemAttribute.value"></textarea>
          </div>
          <div class="itemInput">
            <div><label i18n="@@Style">Style</label></div>
            <select [(ngModel)]="tempPostItem.itemAttribute.class_style">
              <option selected="selected" value=" " i18n="@@Solid Circle">Solid Circle</option>
              <option value="c1" i18n="@@Empty Circle">Empty Circle</option>
              <option value="c2" i18n="@@Square">Square</option>
              <option value="c3" i18n="@@Number">Number</option>
            </select>
          </div>
          <div class="itemInput">
            <div><label i18n="@@Item Width">Item Width</label></div>
            <select [(ngModel)]="tempPostItem.itemAttribute.widthClass">
              <option selected="selected" value="col-12">100%</option>
              <option selected="selected" value="col-9">75%</option>
              <option selected="selected" value="col-6">50%</option>
              <option selected="selected" value="col-4">33%</option>
              <option selected="selected" value="col-3">25%</option>
            </select>
          </div>
        </div>
      </p-tabPanel>
      <p-tabPanel style="height: 500px" *ngIf="tempPostItem.type=='TEXTBOX'" i18n-header="@@Text Box" header="Text Box">
        <div class="item-tabpnl-div">
          <div class="itemInput">
            <div><label i18n="@@Title">Title</label></div>
            <input pInputText [(ngModel)]="tempPostItem.itemAttribute.label"/>
          </div>
          <div class="itemInput">
            <div><label >Type</label></div>
            <select [(ngModel)]="tempPostItem.itemAttribute.type"  style="width: 100%">
              <option value="text">Text</option>
              <option value="json">Json</option>
            </select>

          </div>
          <div class="itemInput">
            <div><label i18n="@@Text">Text</label></div>
            <ngx-suneditor [hidden]="tempPostItem.itemAttribute.type=='json'" #suneditorTextBox style="width: 100%"></ngx-suneditor>
            <textarea  [hidden]="tempPostItem.itemAttribute.type!='json'" style="width: 100%;direction: ltr;" rows="5"  [(ngModel)]="tempPostItem.itemAttribute.value2" pInputTextarea></textarea>

          </div>
          <div class="itemInput">
            <div><label i18n="@@Style">Style</label></div>
            <select [(ngModel)]="tempPostItem.itemAttribute.class_style">
              <option selected="selected" value="searchia-docs-textbox-blue" i18n="@@Blue">Blue</option>
              <option value="searchia-docs-textbox-green" i18n="@@Green">Green</option>
              <option value="searchia-docs-textbox-red" i18n="@@Red">Red</option>
              <option value="searchia-docs-textbox-yellow" i18n="@@Yellow">Yellow</option>
              <option value="searchia-docs-textbox-orang" i18n="@@Orang">Orang</option>
            </select>
          </div>
          <div class="itemInput">
            <div><label i18n="@@Item Width">Item Width</label></div>
            <select [(ngModel)]="tempPostItem.itemAttribute.widthClass">
              <option selected="selected" value="col-12">100%</option>
              <option selected="selected" value="col-9">75%</option>
              <option selected="selected" value="col-6">50%</option>
              <option selected="selected" value="col-4">33%</option>
              <option selected="selected" value="col-3">25%</option>
            </select>
          </div>
        </div>
      </p-tabPanel>

      <!--      ..........................................................-->
      <p-tabPanel style="height: 520px" i18n-header="@@Style Setting" header="Style Setting">
        <div class="grid" style="overflow: auto;max-height: 478px;margin-bottom: 50px;">
          <div class="lg:col-3 sm:col-12">
            <div><label>background-color</label></div>
            <p-colorPicker [(ngModel)]="tempPostItem.style.background_color"></p-colorPicker>
          </div>
          <div class="lg:col-9 sm:col-12">

          </div>

          <div class="lg:col-3 sm:col-12">
            <div><label>font-family</label></div>
            <select [(ngModel)]="tempPostItem.style.font_family">
              <option value="vzr">Vazir</option>
              <option value="Bakh">Yekan</option>
              <option value="tahoma">Tahoma</option>
            </select>
          </div>
          <div class="lg:col-3 sm:col-12">
            <div><label>font-size</label></div>
            <input pInputText [(ngModel)]="tempPostItem.style.font_size"/>
          </div>
          <div class="lg:col-3 sm:col-12">
            <div><label>font-weight</label></div>
            <select [(ngModel)]="tempPostItem.style.font_weight">
              <option value="100">100</option>
              <option value="500">500</option>
              <option value="bold">bold</option>
            </select>
          </div>
          <div class="lg:col-3 sm:col-12">
            <div><label>color</label></div>
            <p-colorPicker [(ngModel)]="tempPostItem.style.color"></p-colorPicker>
          </div>


          <div class="lg:col-3 sm:col-12">
            <div><label>width</label></div>
            <input pInputText [(ngModel)]="tempPostItem.style.width"/>
          </div>
          <div class="lg:col-3 sm:col-12">
            <div><label>height</label></div>
            <input pInputText [(ngModel)]="tempPostItem.style.height"/>
          </div>
          <div class="lg:col-6 sm:col-12">
          </div>

          <div class="lg:col-3 sm:col-12">
            <div><label>margin-top</label></div>
            <input pInputText [(ngModel)]="tempPostItem.style.margin_top"/>
          </div>
          <div class="lg:col-3 sm:col-12">
            <div><label>margin-bottom</label></div>
            <input pInputText [(ngModel)]="tempPostItem.style.margin_bottom"/>
          </div>
          <div class="lg:col-3 sm:col-12">
            <div><label>margin-right</label></div>
            <input pInputText [(ngModel)]="tempPostItem.style.margin_right"/>
          </div>
          <div class="lg:col-3 sm:col-12">
            <div><label>margin-left</label></div>
            <input pInputText [(ngModel)]="tempPostItem.style.margin_left"/>
          </div>
          <div class="lg:col-3 sm:col-12">
            <div><label>padding-top</label></div>
            <input pInputText [(ngModel)]="tempPostItem.style.padding_top"/>
          </div>
          <div class="lg:col-3 sm:col-12">
            <div><label>padding-bottom</label></div>
            <input pInputText [(ngModel)]="tempPostItem.style.padding_bottom"/>
          </div>
          <div class="lg:col-3 sm:col-12">
            <div><label>padding-right</label></div>
            <input pInputText [(ngModel)]="tempPostItem.style.padding_right"/>
          </div>
          <div class="lg:col-3 sm:col-12">
            <div><label>padding-left</label></div>
            <input pInputText [(ngModel)]="tempPostItem.style.padding_left"/>
          </div>
          <div class="lg:col-3 sm:col-12">
            <div><label>border-top-width</label></div>
            <input pInputText [(ngModel)]="tempPostItem.style.border_top_width"/>
          </div>
          <div class="lg:col-3 sm:col-12">
            <div><label>border-bottom-width</label></div>
            <input pInputText [(ngModel)]="tempPostItem.style.border_bottom_width"/>
          </div>
          <div class="lg:col-3 sm:col-12">
            <div><label>border-right-width</label></div>
            <input pInputText [(ngModel)]="tempPostItem.style.border_right_width"/>
          </div>
          <div class="lg:col-3 sm:col-12">
            <div><label>border-left-width</label></div>
            <input pInputText [(ngModel)]="tempPostItem.style.border_left_width"/>
          </div>

          <div class="lg:col-3 sm:col-12">
            <div><label>border-radius</label></div>
            <input pInputText [(ngModel)]="tempPostItem.style.border_radius"/>
          </div>
          <div class="lg:col-3 sm:col-12">
            <div><label>border-style</label></div>
            <input pInputText [(ngModel)]="tempPostItem.style.border_style"/>
          </div>
          <div class="lg:col-3 sm:col-12">
            <div><label>border-color</label></div>
            <p-colorPicker [(ngModel)]="tempPostItem.style.border_color"></p-colorPicker>
          </div>
        </div>
      </p-tabPanel>
    </p-tabView>
    <p-footer>
      <div class="item-config-footer">
        <button pButton i18n-label="@@Cancel" label="Cancel" style="margin-left: 10px" class="p-button-link"
                (click)="configDialog=false"></button>
        <button *ngIf="!itemEditMode" pButton i18n-label="@@Add" label="Add" (click)="addItemToPage()"></button>
        <button *ngIf="itemEditMode" pButton i18n-label="@@Edit" label="Edit" (click)="addItemToPage()"></button>
      </div>
    </p-footer>
  </div>

</div>
